// extracted by mini-css-extract-plugin
export default {"whyChooseContainer":"WhyChoose_whyChooseContainer__LKi26","card":"WhyChoose_card__D53aB","action":"WhyChoose_action__B9ChE"};